import { render } from "./TooltipBody.vue?vue&type=template&id=1b9d083a&scoped=true&lang=pug"
import script from "./TooltipBody.vue?vue&type=script&lang=js"
export * from "./TooltipBody.vue?vue&type=script&lang=js"

import "./TooltipBody.vue?vue&type=style&index=0&id=1b9d083a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9d083a"]])

export default __exports__